export default function (appConfig) {
  return new Promise(function (resolve) {
    const instancesConfigs = {
      'producao': {
        id: 1,
        api: 'https://satacs-api.box00.app',
        developer: {
          name: 'Instituto ACS',
          url: 'https://institutoacs.com.br'
        }
      },
      'dev': {
        id: 1,
        api: 'https://satacs-api.box00.app',
        developer: {
          name: 'DEV - box00.com',
          url: 'https://box00.com'
        }
      }
    }
    const hosts = { 'satacs.box00.app': 'producao' }
    const hostConfig = hosts[window.location.hostname] || 'dev'
    var instance = instancesConfigs[hostConfig]
    resolve(instance)
  })
}
